<template>
  <div class="write-article-wapper">
    <div style="display: flex;justify-content:space-between;">
      <div style="font-size:16px;width:400px">
        <a-input-search placeholder="文章标题" @click="search" enterButton/>
      </div>
      <a-button type="primary" id="write-btn" @click="writeActicle">写文章</a-button>
    </div>
    <div>
      <a-list
        itemLayout="vertical"
        size="large"
        :pagination="pagination"
        :dataSource="articleList"
        :loading="loading"
      >
        <a-list-item slot="renderItem" slot-scope="item" key="item.title">
          <!--  <template slot="actions" v-for="{type, text} in actions">
            <span :key="type">
              <a-icon :type="type" style="margin-right: 8px"/>
              {{text}}
            </span>
          </template>-->
          <!-- <img
            slot="extra"
            width="272"
            alt="logo"
            src="https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png"
          >-->
          <a-list-item-meta :description="item.outline" class="article-item-content">
            <a slot="title" @click="jumpToDetails(item.id)">{{item.publishTitle}}</a>
          </a-list-item-meta>
          {{item.content}}
        </a-list-item>
      </a-list>
    </div>
  </div>
</template>
<script>
import { getArticleList } from '@/apis/article'
export default {
  data () {
    return {
      loading: false,
      articleList: [],
      pagination: {
        onChange: this.onPageChange,
        pageSize: 10,
        pageIndex: 1
      },
      actions: [
        { type: 'star-o', text: '156' },
        { type: 'like-o', text: '156' },
        { type: 'message', text: '2' }
      ]
    }
  },
  methods: {
    writeActicle () {
      let routeData = this.$router.resolve({
        name: '/writeArticle'
      })
      window.open(routeData.href, '_blank')
    },
    onPageChange (page) {
      console.log(page)
    },

    initDataList (query) {
      let params = {
        search: query,
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize
      }
      this.loading = true
      getArticleList(params).then(res => {
        if (res.data.state === 1) {
          this.articleList = res.data.attribute.rows
          let pagination = { ...this.pagination }
          pagination.total = res.data.attribute.count
          this.pagination = pagination
        }
        this.loading = false
      })
    },

    search () {},

    jumpToDetails (id) {
      this.$router.push({ path: `/articles/${id}` }) // -> /user/123);
    }
  },
  mounted () {
    this.initDataList()
  }
}
</script>
<style lang="less" scoped>
.write-article-wapper {
  /* margin: 0 auto;
  width: 800px; */
}
.ant-list-item-meta-description {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-top: 10px;
  line-height: 2;
}
</style>
